import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const PcIllustratedThree = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, value }) => {
  return (
    <div className="illustrated-three-pc" data-model-id="16867:10882">

      <div className="contents">
        <div className="title">
          <p className="heading">Do you relate to the statement below?</p>
        </div>

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/illustrated-three/pc/img.png" alt="Img" className="img" />

          <p className="encouragement-text">
            I need encouragement or I might give up.
          </p>
        </div>
      </div>

      <div className="div">
          <button className={`label-wrapper ${value === "no" && "label-wrapper-select"}`} onClick={() => {clickNext("no")}}>
          <div className="label">No</div>
        </button>

          <button className={`label-wrapper ${value === "yes" && "label-wrapper-select"}`} onClick={() => {clickNext("yes")}}>
          <div className="text-wrapper">Yes</div>
        </button>
      </div>
    </div>
  );
};
